import { API, API_RESPONSE_STATUS_CODES } from "../Utils/Constants";
import { callAPI } from "../config/AxiosTemplate";

//Handle create user
export const createUserAction = (userDetails, callback) => {
  callAPI("CreateUser", API.createUser, "POST", userDetails, (apiResponse) => {
    if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
      callback(apiResponse.data.data);
    } else {
      callback(null);
    }
  });
};

//Handle update user
export const updateUserAction = (userDetails, callback) => {
  callAPI(
    "UpdateUser",
    API.updateUser + userDetails.username,
    "PUT",
    userDetails,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

//Handle Deactivate user
export const deactivateUserAction = (userDetails, callback) => {
  callAPI(
    "DeactivatUser",
    API.deactivateUser,
    "DELETE",
    userDetails,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};

//Handle Photo UPload Action
export const handleUploadPhotoAction = (userId, profilePic, callback) => {
  let request = new FormData();
  request.append("username", userId);
  request.append("file", profilePic);
  callAPI(
    "UploadProfilePic",
    API.uploadProfilePic,
    "POST",
    request,
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    },
    true
  );
};

//Handle get photo upload action of user
export const getProfilePhotoAction = (userId, callback) => {
  callAPI(
    "getProfilePic",
    API.getProfilePic + userId,
    "GET",
    {},
    (apiResponse) => {
      if (apiResponse.data.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        callback(apiResponse.data.data);
      } else {
        callback(null);
      }
    }
  );
};
